import { useForm } from 'react-hook-form';
import type { MfaConfirmationModalFormValues } from './types';

const useMfaConfirmationModalForm = () => {
  const form = useForm<MfaConfirmationModalFormValues>({
    mode: 'onSubmit',
    defaultValues: {
      twoFA: {
        state: '',
        identityType: 'phone',
        code: '',
      },
    },
  });

  const resetCode = () => {
    form.setValue('twoFA.code', '');
  };

  return {
    form,
    resetCode,
  };
};

export { useMfaConfirmationModalForm };
